import React from 'react';
import '../assets/styles/footer.css';

const Footer = () => {
  return (
    <div className="footer-container gradient-bg">
      <div className="footer-content">
        <p>&copy; 2025 Learning Platform. All Rights Reserved.</p>
        <p>Contact us: support@learningplatform.com</p>
      </div>
    </div>
  );
};

export default Footer;
